import { generateUnOrderedList, getCircleTypeListItem, getSquareTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc63 = {
    title: "Image 63: Example of a Visiting Room or Mulakat Room in Jails in Odisha.",
    para1: <>
        <p>This image shows a physical Visiting Room or a Mulakat Room that has been inaugurated at Jharapada Jail in Bhubaneswar.  </p>
        <p>The image shows the Mulakat from the public area which has a counter with several telephones for communication with the undertrials on the other side of the counter, divided by a glass pane. </p>
        <p>The counter also has several marigold garlands which indicates that the picture has been taken at the time of the inauguration.
        </p>
    </>,
}

export const FigureDesc57 = {
    title: "Figure 57: Typical floor plan of a Visiting Room. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure depicts a floor plan for a Visiting Room which includes a waiting area, and separate sections within the room for meetings with lawyers, and with family and friends/other members of the public.
        </p>
        <p>
            A public zone is depicted at the bottom of the layout, through which the Visiting Room can be accessed. A CCTV camera is situated towards the right side of this area to monitor the lock-up facility.
        </p>
        <p>
            The entrance to the Visiting Room for the visitors is provided at the bottom right, above the public zone. The entrance leads to the waiting area at the bottom of the Visiting Room. The rest of the Visiting Room is partitioned into two sections, with the left side being the Public Section and the right side being the Lawyer Section. Separate entrances for the accused (Accused Sections) are provided from the top of the layout, directly into the Public Section and the Lawyer Section respectively.
        </p>
        <p>
            The features are described space-by space.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Waiting area:
                        {getCircleTypeListItem([
                            "At the bottom of the layout, an entrance for visitors is provided from the public zone leading to the waiting area. The entrance is accessible, with a turning diameter of 1500 mm.",
                            "A chair is provided for security personnel to the left of the entrance. ",
                            "Green plants are provided near the seating for the security and at the bottom-left corner of the waiting area.",
                            "Comfortable seating is provided, with three seats along the bottom wall (including wheelchair-accessible seating) and three seats along the left wall of the waiting area.",
                            "A Case Display System is provided opposite to the seats provided on the left, along the partition wall in the Visiting Room, to ensure that real-time case progress in Courtrooms is updated.",
                            "The waiting area leads to the side of the meeting areas occupied by the public and the lawyers, in the Public Section and Lawyer Section respectively.",

                        ])}
                    </>,

                    <>
                        Public Section:
                        {getCircleTypeListItem([
                            "The public section has four separate meeting areas, separated by acoustic partitions to ensure private conversations.",
                            "Each meeting area has a large desk in the centre running from end-to-end, separated by a barrier. Seating (including wheelchair-accessible seating) is provided for the public visitors at the bottom and for the accused at the top. Audio facilities, including a telephone, are provided on both sides to enable conversations.",
                            <>
                                Accused Section:
                                {getSquareTypeListItem([
                                    "At the top-left, on the accused side of this half of the Visiting Room, a separate door is provided for the use of accused persons entering the Visiting Room.",
                                    "A chair for security personnel is provided next to this entrance. Green plants are also provided near this seating.",
                                    "A CCTV camera for monitoring purposes is provided at the top-right corner.",
                                ])}
                            </>

                        ])}
                    </>,

                    <>
                        Lawyer Section:
                        {getCircleTypeListItem([
                            "The lawyer section has two separate meeting areas, separated by a partition with one-way glass on either end (at a distance of 1500 mm from the desk in the centre), to ensure privacy and confidentiality.",
                            "Each meeting area has a large desk running from end to end, separated by a barrier. Seating is provided for the lawyers at the bottom and for the accused at the top. Audio facilities, including a telephone, are provided on both sides to enable conversations.",
                            <>
                                Accused Section:
                                {getSquareTypeListItem([
                                    "At the top-right, on the accused side of this half of the Visiting Room, a separate door is provided for the use of accused persons entering the Visiting Room. ",
                                    "A chair for security personnel is provided next to this entrance. Green plants are also provided near this seating.",
                                    "A CCTV camera for monitoring purposes is provided at the top-left corner.",

                                ])}
                            </>
                        ])}
                    </>,

                ])}
            </div>
        </p>
    </>
}

